// Email and phone number labels
$(document).ready(function () {
  function handleContactLinks() {
    $('a[href^="mailto:"], a[href^="tel:"]').each(function () {
      var $link = $(this);
      var href = $link.attr("href");
      var linkText = $.trim($link.text());

      if (href.startsWith("mailto:")) {
        $link.attr("aria-label", "Email Address: " + linkText);
      } else if (href.startsWith("tel:")) {
        // remove Tel: or Phone:
        linkText = linkText.replace(/^(Tel:|Phone:)\s*/i, "");
        $link.attr("aria-label", "Phone number: " + linkText);
      }
    });
  }

  handleContactLinks();
});

//  br tag hide
$(document).ready(function () {
  $("br").attr("aria-hidden", "true");
  setTimeout(() => {
    $(".menu__item.grandparent").removeAttr("role", "button");
    $(".menu__item.grandparent a.navlink.navlink--toplevel")
      .removeAttr("href")
      .attr("role", "button")
      .attr("aria-expanded", "false")
      .attr("tabindex", "0")
      .attr("aria-haspopup", "false");
  }, 500);
});
//  hr tag hide
$(document).ready(function () {
  $("hr").attr("aria-hidden", "true");
});

// Accessibility Enhancements for Third-Party Links
$(document).ready(function () {
  var excludedLinks = [];

  function isThirdParty(url) {
    try {
      var linkHost = new URL(url, window.location.origin).hostname;
      var currentHost = window.location.hostname;
      return linkHost && linkHost !== currentHost;
    } catch (e) {
      return false;
    }
  }

  function handleExternalLinks() {
    $("a").each(function () {
      var $link = $(this);
      var href = $link.attr("href");

      // ← SKIP OKENDO LINK (NO CLASS NEEDED)
      if (
        !href ||
        !isThirdParty(href) ||
        excludedLinks.includes(href) ||
        href.includes("okendo.reviews") || // 🔥 IMPORTANT SKIP
        $link.hasClass("oke-w-writeReview") // 🔥 OPTIONAL EXTRA SKIP
      )
        return;

      // Always open in new tab
      $link.attr("target", "_blank");
      $link.attr("rel", "noopener noreferrer");

      if (!$link.attr("aria-label")) {
        var existingText = $.trim($link.text());
        var ariaLabel = existingText
          ? existingText + ", This link will open in a new tab"
          : "This link will open in a new tab";
        $link.attr("aria-label", ariaLabel);
      }

      var $img = $link.find("img, svg").first();
      if ($img.length && !$img.attr("alt")) {
        $img.attr("alt", "This link will open in a new tab");
      }
    });
  }

  handleExternalLinks();

  var observer = new MutationObserver(function () {
    handleExternalLinks();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// Replace div with h1
$(document).ready(function () {
  const path = window.location.pathname;

  // Run only if it's the home page
  if (path === "/" || path === "/index.html") {
    const $logoDiv = $(".header__logo.header__logo--image");

    // Replace logo div with h1 only if it isn't already h1
    if ($logoDiv.length && !$logoDiv.is("h1")) {
      const $h1 = $("<h1>", {
        class: $logoDiv.attr("class"),
        html: $logoDiv.html(),
      });
      $logoDiv.replaceWith($h1);
    }
  }
});

// Find the "Previous" button and update its aria-label and "Next" button within slider-component
$(document).ready(function () {
  // Homepage Banner Slider
  $(
    ".slider-component--hero, .slider-component--banner, .homepage-banner slider-component"
  ).each(function () {
    const $slider = $(this);

    $slider
      .find(".flickity-button.next")
      .attr("aria-label", "Next slide of Homepage Banner");

    $slider
      .find(".flickity-button.previous")
      .attr("aria-label", "Previous slide of Homepage Banner");
  });

  // Announcement Bar Slider
  $(".announcement__bar-holder slider-component").each(function () {
    const $announcement = $(this);

    $announcement
      .find(".flickity-button.next")
      .attr("aria-label", "Show next announcement");

    $announcement
      .find(".flickity-button.previous")
      .attr("aria-label", "Show previous announcement");
  });
});
$(document).ready(function () {
  // Target homepage main slideshow (specific ID pattern or class)
  $("slider-component.slideshow__slider").each(function () {
    const $slider = $(this);

    // Fix Next button label
    $slider
      .find(".flickity-button.next")
      .attr("aria-label", "Next slide of Homepage Banner");

    // Fix Previous button label
    $slider
      .find(".flickity-button.previous")
      .attr("aria-label", "Previous slide of Homepage Banner");
  });
});

// When close button is clicked → return focus to main search button
$(document).ready(function () {
  const $searchToggle = $(".navlink--search");
  const $closeButton = $(".search-popdown__close__button");

  $closeButton.on("click", function () {
    $searchToggle.trigger("focus");
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      const $dialog = $('.search-popdown[aria-modal="true"]');
      if ($dialog.is(":visible") && $dialog.find(":focus").length > 0) {
        setTimeout(function () {
          $searchToggle.trigger("focus");
        }, 150);
      }
    }
  });
});

//  Focus return when Close button clicked cart drawer
$(document).ready(function () {
  const $cartButton = $(".navlink--cart");
  const $cartDrawer = $("[data-cart-drawer-inner]");
  const $cartCloseBtn = $("[data-cart-drawer-close]");

  let isCartOpen = false;

  // detect when cart opens
  $(document).on("click", "[data-cart-toggle]", function () {
    isCartOpen = true;
  });

  // close button click → focus back
  $cartCloseBtn.on("click", function () {
    if (isCartOpen) {
      $cartButton.focus();
      isCartOpen = false;
    }
  });

  // Escape key → only if cart is open
  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && isCartOpen) {
      setTimeout(() => {
        $cartButton.focus();
        isCartOpen = false;
      }, 300);
    }
  });
});

// Implemented dynamic aria-current update for swatch links to improve accessibility for VoiceOver and other screen readers.
$(document).ready(function () {
  function updateAriaCurrent() {
    $(".sibling__link").each(function () {
      const isCurrent = $(this).hasClass("sibling__link--current");
      $(this).attr("aria-current", isCurrent ? "true" : "false");
    });
  }

  // Run initially
  updateAriaCurrent();

  // Observe DOM changes
  const container = document.querySelector(".radio__buttons");
  if (container) {
    const observer = new MutationObserver(() => updateAriaCurrent());
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  // Fallback: also check every 1 second (for JS replacements)
  setInterval(updateAriaCurrent, 1000);
});

// proper radio button name reading
// $(document).ready(function () {
//   // Mapping short sizes to full readable words
//   const sizeMap = {
//     "XS": "Extra Small",
//     "S": "Small",
//     "M": "Medium",
//     "L": "Large",
//     "XL": "Extra Large",
//     "2XL": "Double Extra Large",
//     "XXL": "Double Extra Large",
//     "3XL": "Triple Extra Large"
//   };

//   function updateAriaLabels() {
//     $('.radio__buttons input[type="radio"]').each(function () {
//       const $input = $(this);
//       const $label = $(`label[for='${$input.attr('id')}']`);
//       const labelText = $label.find('.option-title').text().trim().toUpperCase();

//       if (labelText) {
//         // Convert short form to full form
//         const readableText = sizeMap[labelText] || labelText;

//         // Add aria-label with full name
//         $input.attr('aria-label', readableText);

//         //  Hide label from screen readers
//         $label.attr('aria-hidden', 'true');
//       }
//     });
//   }

//   // Initial run
//   updateAriaLabels();

//   // Observe for dynamic changes (e.g. Shopify re-render)
//   const container = document.querySelector('.radio__buttons');
//   if (container) {
//     const observer = new MutationObserver(() => updateAriaLabels());
//     observer.observe(container, {
//       childList: true,
//       subtree: true,
//       attributes: true
//     });
//   }

//   // Fallback periodic update
//   setInterval(updateAriaLabels, 1500);
// });
$(document).ready(function () {
  const sizeMap = {
    XS: "Extra Small",
    S: "Small",
    M: "Medium",
    L: "Large",
    XL: "Extra Large",
    "2XL": "Double Extra Large",
    XXL: "Double Extra Large",
    "3XL": "Triple Extra Large",
  };

  function updateAriaLabels() {
    $('.radio__buttons input[type="radio"]').each(function () {
      const $input = $(this);
      const $label = $(`label[for='${$input.attr("id")}']`);
      const labelText = $label
        .find(".option-title")
        .text()
        .trim()
        .toUpperCase();

      if (labelText) {
        // Extract first part (size code only)
        const sizeCode = labelText.split(" ")[0]; // XS, S, M, L, etc.
        const readableText = sizeMap[sizeCode] || sizeCode;

        // Add aria-label with full name + remaining info
        const remainingText = labelText.split(" ").slice(1).join(" ");
        const finalLabel = remainingText
          ? `${readableText} ${remainingText}`
          : readableText;

        $input.attr("aria-label", finalLabel);

        // Hide label from screen readers
        $label.attr("aria-hidden", "true");
      }
    });
  }

  updateAriaLabels();

  const container = document.querySelector(".radio__buttons");
  if (container) {
    const observer = new MutationObserver(() => updateAriaLabels());
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }

  setInterval(updateAriaLabels, 1500);
});

// Quick Add button click → store last clicked button
$(document).ready(function () {
  let lastClickedQuickAdd = null;
  $(document).on("click", "[data-quick-add-btn]", function () {
    lastClickedQuickAdd = this;
  });

  // Drawer close button click
  $(document).on("click", "[data-quick-add-modal-close]", function () {
    const drawer = $(this).closest(
      ".drawer__inner.product-quick-add__content"
    )[0];
    if (!drawer || !lastClickedQuickAdd) return;

    // Observe drawer attributes for "is-disabled" or style changes
    const observer = new MutationObserver(() => {
      const holder = $(lastClickedQuickAdd).closest(".quick-add__holder");
      if (!holder.hasClass("is-disabled")) {
        // Drawer fully closed, restore focus
        $(lastClickedQuickAdd).focus();
        observer.disconnect();
        lastClickedQuickAdd = null;
      }
    });

    observer.observe(document, {
      attributes: true,
      subtree: true,
      attributeFilter: ["class", "style"],
    });
  });

  // Escape key handling
  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && lastClickedQuickAdd) {
      const holder = $(lastClickedQuickAdd).closest(".quick-add__holder");
      const drawer = $(".drawer__inner.product-quick-add__content:visible")[0];
      if (drawer) {
        const observer = new MutationObserver(() => {
          if (!holder.hasClass("is-disabled")) {
            $(lastClickedQuickAdd).focus();
            observer.disconnect();
            lastClickedQuickAdd = null;
          }
        });
        observer.observe(document, {
          attributes: true,
          subtree: true,
          attributeFilter: ["class", "style"],
        });
      }
    }
  });
});

// sort-by dropdown accessibility and focus management
$(document).ready(function () {
  $(".popout-select").each(function () {
    var $dropdown = $(this);
    var $button = $dropdown.find(".popout__toggle");
    var $list = $dropdown.find("[data-popout-list]");
    var isOpen = false;

    $button.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      isOpen = $button.attr("aria-expanded") === "false";
      $button.attr("aria-expanded", isOpen);

      if (isOpen) {
        $list.show();

        $(document).on("click.popoutDismiss", function (evt) {
          if (!$.contains($dropdown[0], evt.target)) {
            closeDropdown();
          }
        });

        $(document).on("keydown.popoutEscape", function (evt) {
          if (evt.key === "Escape") {
            evt.preventDefault();
            evt.stopPropagation(); // <-- Stop global Escape
            closeDropdown();
          }
        });
      } else {
        closeDropdown();
      }
    });

    function closeDropdown() {
      $button.attr("aria-expanded", false);
      $list.hide();
      isOpen = false;
      $button.focus();
      $(document).off("click.popoutDismiss");
      $(document).off("keydown.popoutEscape");
    }
  });
});

// checkout  Accessibility for Pickup Drawer availability at store
function enhancePickupAccessibility() {
  const $drawer = $(".drawer__inner");

  // 1. Add aria-hidden="true" to <br> tags
  $drawer.find("br").each(function () {
    if (!$(this).attr("aria-hidden")) {
      $(this).attr("aria-hidden", "true");
    }
  });

  // 2. Add proper aria-label to phone links
  $drawer.find('a[href^="tel"], a[href^="+"]').each(function () {
    let phone = $(this).text().trim();

    // Remove all spaces and non-digit characters except '+'
    phone = phone.replace(/[^\d+]/g, "");

    // Format into +1-XXX-XXX-XXXX if possible
    const match = phone.match(/^(\+?1)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const formattedPhone = `${match[1] || "+1"}-${match[2]}-${match[3]}-${
        match[4]
      }`;
      $(this).attr("aria-label", `Call us at ${formattedPhone}`);
    } else {
      // fallback if not a 10-digit US-style number
      $(this).attr("aria-label", `Call us at ${phone}`);
    }
  });

  // 3. Ensure role="listitem" on pickup items
  $drawer.find(".pickup__list__item").each(function () {
    if (!$(this).attr("role")) {
      $(this).attr("role", "listitem");
    }
  });
}

// Run immediately and again with delay
enhancePickupAccessibility();
setTimeout(enhancePickupAccessibility, 200);
setInterval(enhancePickupAccessibility, 1000);

// add to cart button focus return after cart drawer close
$(document).ready(function () {
  let lastAddToCartButton = null;

  // Store the last clicked Add to Cart button
  $("[data-add-to-cart]").on("click", function (e) {
    e.preventDefault();
    lastAddToCartButton = $(this);

    // Show loading state
    $(this).addClass("is-added").prop("disabled", true);

    // Simulate add to cart process (replace with your actual cart logic)
    setTimeout(() => {
      // After cart update, open drawer and then setup focus
      setupCartCloseFocus();
    }, 500);
  });

  function setupCartCloseFocus() {
    // Remove previous event listeners to avoid duplicates
    $("[data-cart-drawer-close]").off("click.focus");
    $(document).off("keydown.focus");

    // Cart drawer close button click event
    $("[data-cart-drawer-close]").on("click.focus", function () {
      setTimeout(() => {
        if (lastAddToCartButton && lastAddToCartButton.length) {
          lastAddToCartButton.prop("disabled", false).focus();
          console.log("Focus set on Add to Cart button after close click");
        }
      }, 300);
    });

    // Escape key press event
    $(document).on("keydown.focus", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        // Check if cart drawer is visible
        if (
          $("[data-cart-drawer]").is(":visible") ||
          $(".drawer__inner").is(":visible")
        ) {
          setTimeout(() => {
            if (lastAddToCartButton && lastAddToCartButton.length) {
              lastAddToCartButton.prop("disabled", false).focus();
              console.log("Focus set on Add to Cart button after Escape key");
            }
          }, 300);
        }
      }
    });
  }

  // Alternative approach using MutationObserver to detect drawer close
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        const target = $(mutation.target);
        if (target.is("[data-cart-drawer]") || target.is(".drawer__inner")) {
          if (!target.is(":visible") && lastAddToCartButton) {
            setTimeout(() => {
              lastAddToCartButton.prop("disabled", false).focus();
              console.log("Focus set on Add to Cart button after drawer close");
            }, 200);
          }
        }
      }
    });
  });

  // Start observing cart drawer elements
  if ($("[data-cart-drawer]").length) {
    observer.observe($("[data-cart-drawer]")[0], {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
  if ($(".drawer__inner").length) {
    observer.observe($(".drawer__inner")[0], {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
});

// tab panel accessibility on selected tab change
$(document).ready(function () {
  // Initialize tabs with correct ARIA attributes
  function initializeTabs() {
    $(".product-tabs-title .tab-link").each(function () {
      const $tab = $(this);
      const isCurrent = $tab.hasClass("current");
      const tabIndex = $tab.data("tab");

      // Set role and ARIA attributes for tabs
      $tab.attr({
        role: "tab",
        "aria-selected": isCurrent ? "true" : "false",
        "aria-current": isCurrent ? "true" : "false",
        id: `tab-${tabIndex}`,
      });
    });

    // Initialize tab content with correct ARIA attributes
    $(".tab-content").each(function () {
      const $content = $(this);
      const contentIndex = $content.attr("class").match(/tab-content-(\d+)/)[1];
      const isCurrent = $content.hasClass("current");

      // Set correct ARIA attributes for tab content
      $content.attr({
        role: "tabpanel",
        "aria-labelledby": `tab-${contentIndex}`,
        "aria-hidden": isCurrent ? "false" : "true",
        tabindex: "0",
      });
    });
  }

  // Tab click handler
  $(".product-tabs-title .tab-link").on("click", function () {
    const $clickedTab = $(this);
    const tabIndex = $clickedTab.data("tab");

    // Remove current class and ARIA attributes from all tabs
    $(".product-tabs-title .tab-link").removeClass("current").attr({
      "aria-selected": "false",
      "aria-current": "false",
    });

    // Add current class and ARIA attributes to clicked tab
    $clickedTab.addClass("current").attr({
      "aria-selected": "true",
      "aria-current": "true",
    });

    // Update tab content visibility and ARIA attributes
    $(".tab-content").removeClass("current").attr("aria-hidden", "true");

    $(`.tab-content-${tabIndex}`)
      .addClass("current")
      .attr("aria-hidden", "false");
  });

  // Tab keyboard navigation
  $(".product-tabs-title .tab-link").on("keydown", function (e) {
    const $currentTab = $(this);
    const tabs = $(".product-tabs-title .tab-link");
    const currentIndex = tabs.index($currentTab);

    switch (e.key) {
      case "ArrowRight":
      case "Right":
        e.preventDefault();
        const nextTab = tabs.eq((currentIndex + 1) % tabs.length);
        nextTab.trigger("click").focus();
        break;

      case "ArrowLeft":
      case "Left":
        e.preventDefault();
        const prevTab = tabs.eq((currentIndex - 1 + tabs.length) % tabs.length);
        prevTab.trigger("click").focus();
        break;

      case "Home":
        e.preventDefault();
        tabs.first().trigger("click").focus();
        break;

      case "End":
        e.preventDefault();
        tabs.last().trigger("click").focus();
        break;

      case "Enter":
      case "Space":
        e.preventDefault();
        $(this).trigger("click");
        break;
    }
  });

  // Initialize tabs on page load
  initializeTabs();
});

// Function to update tab content (adjust according to your content structure)
$(document).ready(function () {
  // Initialize tabs with ARIA attributes
  function initializeTabs() {
    $(".tabs.text-center .tab-link").each(function () {
      const $tab = $(this);
      const isCurrent = $tab.hasClass("current");

      // Update ARIA attributes
      $tab.attr({
        "aria-selected": isCurrent ? "true" : "false",
        "aria-current": isCurrent ? "true" : "false",
      });
    });
  }

  // Tab click handler
  $(".tabs.text-center .tab-link").on("click", function () {
    const $clickedTab = $(this);
    const tabIndex = $clickedTab.data("tab");

    // Remove current class and ARIA attributes from all tabs
    $(".tabs.text-center .tab-link").removeClass("current").attr({
      "aria-selected": "false",
      "aria-current": "false",
    });

    // Add current class and ARIA attributes to clicked tab
    $clickedTab.addClass("current").attr({
      "aria-selected": "true",
      "aria-current": "true",
    });

    // Update tab content visibility
    updateTabContent(tabIndex);
  });

  // Tab keyboard navigation
  $(".tabs.text-center .tab-link").on("keydown", function (e) {
    const $currentTab = $(this);
    const tabs = $(".tabs.text-center .tab-link");
    const currentIndex = tabs.index($currentTab);

    switch (e.key) {
      case "ArrowRight":
      case "Right":
        e.preventDefault();
        const nextTab = tabs.eq((currentIndex + 1) % tabs.length);
        nextTab.trigger("click").focus();
        break;

      case "ArrowLeft":
      case "Left":
        e.preventDefault();
        const prevTab = tabs.eq((currentIndex - 1 + tabs.length) % tabs.length);
        prevTab.trigger("click").focus();
        break;

      case "Home":
        e.preventDefault();
        tabs.first().trigger("click").focus();
        break;

      case "End":
        e.preventDefault();
        tabs.last().trigger("click").focus();
        break;

      case "Enter":
      case " ":
        e.preventDefault();
        $(this).trigger("click");
        break;
    }
  });

  function updateTabContent(tabIndex) {
    // Hide all tab contents
    $(".tab-content").removeClass("current").attr("aria-hidden", "true");

    // Show selected tab content
    $(`.tab-content-${tabIndex}`)
      .addClass("current")
      .attr("aria-hidden", "false");

    console.log(`Switched to tab ${tabIndex}`);
  }

  // Initialize tabs on page load
  initializeTabs();
});

// =======================================================
// CLICK-BASED DROPDOWN (replacement for hover-disclosure)
// =======================================================

const Ne = "is-visible"; // active/visible state class
const Re = "meganav--visible"; // wrapper visible class
const Ue = "meganav--is-transitioning"; // transition state
const $e = "[data-stagger]"; // stagger animation selector
const Be = "[data-stagger-first]";
const We = "[data-stagger-second]";

if (!customElements.get("click-disclosure")) {
  customElements.define(
    "click-disclosure",
    class extends HTMLElement {
      connectedCallback() {
        // Setup accessibility attributes
        this.setAttribute("aria-controls", this.key || "");

        // Initialize
        this.connectClickToggle();
        this.handleTablets();
        this.staggerChildAnimations();
      }

      // ------------------------------------------
      // Show dropdown
      // ------------------------------------------
      showDisclosure(e) {
        if (e && e.type === "click") {
          this.wrapper?.classList.add(Ue);
        }

        if (this.grandparent) {
          this.wrapper?.classList.add(Re);
        } else {
          this.wrapper?.classList.remove(Re);
        }

        // Add is-visible and aria-expanded only for this disclosure
        $(this).find(".header__dropdown").addClass("is-visible");
        $(this).find("a.navlink--toplevel").attr("aria-expanded", "true");

        this.classList.add(Ne);
        this.disclosure?.classList.add(Ne);

        if (this.transitionTimeout) clearTimeout(this.transitionTimeout);
        this.transitionTimeout = setTimeout(() => {
          this.wrapper?.classList.remove(Ue);
        }, 200);
      }

      // ------------------------------------------
      // Hide dropdown
      // ------------------------------------------
      hideDisclosure() {
        this.classList.remove(Ne);
        this.disclosure?.classList.remove(Ne);
        // this.setAttribute("aria-expanded", "false");
        $(".menu__item.grandparent a.navlink.navlink--toplevel").attr(
          "aria-expanded",
          "false"
        );
        this.wrapper?.classList.remove(Re, Ue);
      }

      // ------------------------------------------
      // Handle click toggle
      // ------------------------------------------
      connectClickToggle() {
        // Toggle dropdown on click
        this.addEventListener("click", (event) => {
          event.stopPropagation();

          const isOpen = this.classList.contains(Ne);
          const $currentDropdown = $(this).find(".header__dropdown"); // only this dropdown

          // Close all other dropdowns
          $("click-disclosure")
            .not(this)
            .removeClass(Ne)
            .find(".header__dropdown")
            .removeClass("is-visible");

          if (isOpen) {
            this.hideDisclosure();
            $currentDropdown.removeClass("is-visible");
          } else {
            this.showDisclosure(event);
            $currentDropdown.addClass("is-visible");
          }
        });

        // Close when clicking anywhere outside
        document.addEventListener("click", (event) => {
          if (!this.contains(event.target)) {
            this.hideDisclosure();
          }
        });
      }

      // ------------------------------------------
      // Animate child elements
      // ------------------------------------------
      staggerChildAnimations() {
        const staggerItems = this.querySelectorAll($e);
        let delay = 50;

        staggerItems.forEach((el, i) => {
          el.style.transitionDelay = i * delay + 10 + "ms";
          delay *= 0.95;
        });

        this.querySelectorAll(Be).forEach((first, i) => {
          const firstDelay = 100 * i;
          first.style.transitionDelay = `${firstDelay}ms`;

          first.parentElement?.querySelectorAll(We).forEach((second, j) => {
            const secondDelay = 20 * (j + 1);
            second.style.transitionDelay = `${firstDelay + secondDelay}ms`;
          });
        });
      }

      // ------------------------------------------
      // Handle touch (for tablets)
      // ------------------------------------------
      handleTablets() {
        this.addEventListener(
          "touchstart",
          function (e) {
            if (!this.classList.contains(Ne)) {
              e.preventDefault();
              this.showDisclosure(e);
            }
          }.bind(this),
          { passive: true }
        );
      }
    }
  );
}

// quick focus return to cart button after cart drawer close
$(document).ready(function () {
  // Cache cart toggle button
  var $cartToggle = $("[data-cart-toggle]");
  var $cartDrawer = $("[data-cart-drawer-inner]");

  // Function to move focus back to cart button
  function focusBackToCartButton() {
    setTimeout(function () {
      $cartToggle.trigger("focus");
    }, 150); // delay for smooth transition
  }

  // When the "Close Cart" button is clicked
  $(document).on("click", "[data-cart-drawer-close]", function () {
    focusBackToCartButton();
  });

  // Scoped ESC key — only when cart drawer is open and visible
  $cartDrawer.on("keydown", function (e) {
    if ((e.key === "Escape" || e.keyCode === 27) && $(this).is(":visible")) {
      focusBackToCartButton();
    }
  });
});

// excape key to close open dropdown menus on desktop
// $(document).ready(function() {

//     $(document).keydown(function(e) {

//         if (e.keyCode === 27) {

//             var $openMenu = $('[aria-expanded="true"]').filter('.navlink--toplevel');

//             if ($openMenu.length > 0) {

//                 $openMenu.trigger('click');

//                 closeAllMenus();
//             }
//         }
//     });

//     function closeAllMenus() {
//         $('.navlink--toplevel').attr('aria-expanded', 'false');
//         $('click-disclosure').attr('aria-expanded', 'false');

//         $('.header__dropdown').hide();
//         $('.header__dropdown').removeClass('is-visible');
//     }

//     $('.navlink--toplevel').click(function(e) {
//         e.preventDefault();

//         var $this = $(this);
//         var $parentDisclosure = $this.closest('click-disclosure');
//         var isExpanded = $this.attr('aria-expanded') === 'true';

//         closeAllMenus();

//         if (!isExpanded) {
//             $this.attr('aria-expanded', 'true');
//             $parentDisclosure.attr('aria-expanded', 'true');

//             $parentDisclosure.find('.header__dropdown').show();
//             $parentDisclosure.find('.header__dropdown').addClass('is-visible');
//         }
//     });
// });

// mobile menu close button → focus back to hamburger button
$(document).ready(function () {
  // Cache the hamburger (menu open) button
  var $menuToggle = $('[data-drawer-toggle="hamburger"]');

  // Function to focus back to menu button
  function focusBackToMenuButton() {
    setTimeout(function () {
      $menuToggle.trigger("focus");
    }, 150); // small delay ensures animations complete
  }

  // When user clicks the mobile menu close button
  $(document).on(
    "click",
    '[data-drawer-close][aria-controls="header-menu"]',
    function () {
      focusBackToMenuButton();
    }
  );
});

// remove aria-haspopup and aria-expanded from mobile menu buttons
$(document).ready(function () {
  // Check if mobile device
  function isMobile() {
    return window.innerWidth <= 768;
  }

  // Remove attributes from buttons on mobile
  function removeMobileAttributes() {
    if (isMobile()) {
      $('button[aria-haspopup="true"][aria-expanded="false"]').each(
        function () {
          $(this).removeAttr("aria-haspopup");
          $(this).removeAttr("aria-expanded");
          $(this).removeAttr("aria-controls");
          $(this).removeAttr("data-sliderule-open");
        }
      );
    }
  }

  // Run on page load
  removeMobileAttributes();

  // Run on window resize
  $(window).resize(function () {
    removeMobileAttributes();
  });
});

// focus management for mobile sliderule menus
$(document).ready(function () {
  // Check if jQuery is loaded
  if (typeof jQuery === "undefined") {
    console.error("jQuery not loaded");
    return;
  }

  // Store the last clicked trigger button
  let lastTriggerButton = null;

  // When any sliderow button is clicked (menu opener)
  $(document).on(
    "click",
    'mobile-sliderule .sliderow[aria-label*="open"]',
    function () {
      console.log("Menu button clicked");
      lastTriggerButton = $(this);

      // Wait for menu to open then focus on back button
      setTimeout(function () {
        // Find the back button in the opened panel
        var backButton = $(
          ".sliderule__panel.is-visible .sliderow__back-button"
        );
        console.log("Back button found:", backButton.length);
        if (backButton.length) {
          backButton.focus();
          console.log("Focus set on back button");
        }
      }, 300);
    }
  );

  // When back button is clicked
  $(document).on("click", ".sliderow__back-button", function () {
    console.log("Back button clicked");
    if (lastTriggerButton && lastTriggerButton.length) {
      // Small delay to allow menu to close
      setTimeout(function () {
        lastTriggerButton.focus();
        console.log("Focus set back on trigger button");
      }, 100);
    }
  });
});

// add visually hidden labels for product prices
$(document).ready(function () {
  $(".product__price__wrap").each(function () {
    var $wrapper = $(this);
    var $price = $wrapper.find("[data-product-price]");
    var $salePrice = $wrapper.find(".product__price--sale");
    var $comparePrice = $wrapper.find("[data-compare-price]");
    var $sale = $wrapper.find(".product__sale");

    //  Condition 1: Product on SALE (both sale + compare price exist)
    if ($salePrice.length && $comparePrice.length) {
      if ($wrapper.find(".visually-hidden[data-sale-text]").length === 0) {
        $salePrice.before(
          '<span class="visually-hidden" data-sale-text="">Sale price</span>'
        );
      }
    }

    //  Condition 2: Regular product (no sale or sale section hidden)
    else if ($sale.length === 0 || $sale.hasClass("hidden")) {
      if ($wrapper.find(".visually-hidden[data-regular-text]").length === 0) {
        $price.before(
          '<span class="visually-hidden" data-regular-text="">Regular price</span>'
        );
      }
    }
  });
});
// add price label for single price products quick add
// Function to handle adding visually hidden spans
function addRegularPriceSpan($wrapper) {
  var $price = $wrapper.find("[data-product-price]");
  var $sale = $wrapper.find(".product__sale");
  var $comparePrice = $wrapper.find("[data-compare-price]");

  // Condition: only single price (no sale, no compare price)
  if (
    ($sale.length === 0 || $sale.hasClass("hidden")) &&
    $comparePrice.length === 0
  ) {
    if ($wrapper.find(".visually-hidden[data-regular-text]").length === 0) {
      $price.before(
        '<span class="visually-hidden" data-regular-text="">Regular price</span>'
      );
    }
  }
}

// Initial scan
$(".product__price__wrap").each(function () {
  addRegularPriceSpan($(this));
});

// Observe for dynamically added products
var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType === 1) {
        // Element node
        var $node = $(node);
        // If new product__price__wrap added
        if ($node.hasClass("product__price__wrap")) {
          addRegularPriceSpan($node);
        } else {
          // Check inside subtree
          $node.find(".product__price__wrap").each(function () {
            addRegularPriceSpan($(this));
          });
        }
      }
    });
  });
});

// Start observing the body (or specific container)
observer.observe(document.body, { childList: true, subtree: true });

// mega menu "Shop All" links aria-labels
$(document).ready(function () {
  $("a.navlink.navlink--grandchild").each(function () {
    const link = $(this);
    const href = link.attr("href");

    // Check if link text is "Shop All" and href exists
    if (link.find("span.navtext").text().trim() === "Shop All" && href) {
      // extract collection name from href (e.g., men, women, kids)
      const collectionName =
        href.split("/collections/")[1]?.replace(/[-_]/g, " ") || "";
      const labelText = `Shop All ${
        collectionName.charAt(0).toUpperCase() + collectionName.slice(1)
      }`;

      // add aria-label
      link.attr("aria-label", labelText);
    }
  });
});

// focus management for collection filter drawer on mobile
$(document).ready(function () {
  // Mobile filter button click event
  $(".popout__toggle--filters").on("click", function () {
    // Thoda delay dekar focus set karein taki drawer properly open ho jaye
    setTimeout(function () {
      $(".collection__sidebar__close").focus();
    }, 300);
  });

  // Drawer close button click event
  $(".collection__sidebar__close").on("click", function () {
    // Thoda delay dekar focus set karein taki drawer properly close ho jaye
    setTimeout(function () {
      $(".popout__toggle--filters").focus();
    }, 300);
  });
});

// product gallery thumbnail aria attributes and focus management
$(document).ready(function () {
  // Function to update aria attributes
  function updateGalleryAria() {
    const $thumbs = $(".product__thumb");
    const total = $thumbs.length;

    $thumbs.each(function (index) {
      const $thumb = $(this);
      const $link = $thumb.find(".product__thumb__link");

      // Add role and dynamic aria-label
      $link.attr("role", "button");
      $link.attr(
        "aria-label",
        `Load image ${index + 1} of ${total} in gallery view`
      );

      // Update aria-current based on active class
      if ($thumb.hasClass("is-active")) {
        $link.attr("aria-current", "true");
      } else {
        $link.attr("aria-current", "false");
      }
    });
  }

  // Initial setup
  updateGalleryAria();

  // Whenever active class changes dynamically
  // (for example on click)
  $(document).on("click", ".product__thumb__link", function () {
    $(".product__thumb").removeClass("is-active");
    $(this).closest(".product__thumb").addClass("is-active");
    updateGalleryAria();
  });
});

// shop now add label text
$(document).ready(function () {
  $(".hero__content").each(function () {
    var $block = $(this);

    // Heading/Subheading text
    var headingText = "";

    if ($block.find(".hero__subheading").length > 0) {
      headingText = $block.find(".hero__subheading").first().text().trim();
    } else if ($block.find(".hero__title").length > 0) {
      headingText = $block.find(".hero__title").first().text().trim();
    }

    // Button text
    $block.find(".hero__button a").each(function () {
      var $btn = $(this);
      var btnText = $btn.text().trim();
      var ariaLabel = btnText;

      if (headingText.length > 0) {
        ariaLabel = btnText + ", " + headingText;
      }

      $btn.attr("aria-label", ariaLabel);
    });
  });
});

// add label to EDPB members link privacy-policy
$(function () {
  $('a[href="https://edpb.europa.eu/about-edpb/about-edpb/members"]').attr({
    "aria-label":
      "Click here to visit the European Data Protection Board members page — this link will open in a new tab",
    target: "_blank",
    rel: "noopener noreferrer",
  });
});

// excpe key to close open dropdown menus on desktop with focus return
$(document).ready(function () {
  $(document).keydown(function (e) {
    if (e.keyCode === 27) {
      // Escape key

      var $openMenu = $('[aria-expanded="true"]').filter(".navlink--toplevel");

      if ($openMenu.length > 0) {
        // Store reference to the open menu before closing
        var $parentDisclosure = $openMenu.closest("click-disclosure");

        // Close all menus first
        closeAllMenus();

        // Return focus to the button that opened the menu
        $openMenu.focus();
      }
    }
  });

  function closeAllMenus() {
    // Only remove aria-expanded from elements that should have it
    $(".navlink--toplevel[aria-expanded]").attr("aria-expanded", "false");
    $("click-disclosure[aria-expanded]").attr("aria-expanded", "false");

    // Hide dropdowns
    $(".header__dropdown").hide();
    $(".header__dropdown").removeClass("is-visible");
  }

  // Only attach click handler to menu buttons, not all top-level nav links
  $(".navlink--toplevel").click(function (e) {
    e.preventDefault();

    var $this = $(this);
    var $parentDisclosure = $this.closest("click-disclosure");

    // Check if this is actually a menu button (has a dropdown)
    var hasDropdown = $parentDisclosure.find(".header__dropdown").length > 0;

    if (!hasDropdown) {
      // This is just a regular link, let it behave normally
      window.location.href = $this.attr("href");
      return;
    }

    var isExpanded = $this.attr("aria-expanded") === "true";

    // Close all menus first
    closeAllMenus();

    // Only toggle if this element has a dropdown
    if (!isExpanded) {
      $this.attr("aria-expanded", "true");
      $parentDisclosure.attr("aria-expanded", "true");

      // Show the dropdown
      $parentDisclosure.find(".header__dropdown").show();
      $parentDisclosure.find(".header__dropdown").addClass("is-visible");
    }
  });

  let lastFocusedMenu = null;

  $(".menu__item > a.navlink").on("click", function (e) {
    lastFocusedMenu = $(this);
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      $(".menu__item > a.navlink").attr("aria-expanded", "false");
      $(".menu__item").removeClass("is-visible");

      if (lastFocusedMenu) {
        lastFocusedMenu.focus();
      }
    }
  });
});

//detail tag in footer transform on desktop only footer accessibility
$(document).ready(function () {
  var origStore = {};
  var uidCounter = 0;
  var mq = window.matchMedia("(min-width: 1024px)");
  var $footer = $("footer.site-footer-wrapper");

  function copyAttributes(srcElem, targetJq) {
    $.each(srcElem.attributes, function () {
      targetJq.attr(this.name, this.value);
    });
  }

  function transformToDesktop() {
    // 1) Replace <details.footer__block--menu> → <div> (footer scoped)
    $footer.find("details.footer__block.footer__block--menu").each(function () {
      var $orig = $(this);
      if ($orig.attr("data-repl-uid")) return;

      uidCounter++;
      var uid = "footer-repl-" + uidCounter;
      origStore[uid] = $orig.prop("outerHTML");

      var $new = $("<div>");
      copyAttributes(this, $new);
      $new.html($orig.html());
      $new.attr("data-repl-uid", uid);

      $orig.replaceWith($new);
    });

    // 2) <summary> → <h2> (footer scoped)
    $footer.find("summary").each(function () {
      var $orig = $(this);
      if ($orig.attr("data-repl-uid")) return;

      uidCounter++;
      var uid = "footer-repl-" + uidCounter;
      origStore[uid] = $orig.prop("outerHTML");

      var $new = $("<h2>");
      copyAttributes(this, $new);
      $new.html($orig.html());
      $new.attr("data-repl-uid", uid);

      $orig.replaceWith($new);
    });

    // 3) h3.footer__block__title.heading-medium → h2 (footer scoped)
    $footer.find("h3.footer__block__title.heading-medium").each(function () {
      var $orig = $(this);
      if ($orig.attr("data-repl-uid")) return;

      uidCounter++;
      var uid = "footer-repl-" + uidCounter;
      origStore[uid] = $orig.prop("outerHTML");

      var $new = $("<h2>");
      copyAttributes(this, $new);
      $new.html($orig.html());
      $new.attr("data-repl-uid", uid);

      $orig.replaceWith($new);
    });

    // 4) Remove data-collapsible-content from <ul> (footer scoped)
    $footer.find("ul[data-collapsible-content]").each(function () {
      var $el = $(this);
      if ($el.attr("data-repl-uid")) return;

      uidCounter++;
      var uid = "footer-repl-" + uidCounter;
      origStore[uid] = $el.prop("outerHTML");

      $el.attr("data-repl-uid", uid);
      $el.removeAttr("data-collapsible-content");
    });

    // 5) Remove data-collapsible-body from <div> (footer scoped)
    $footer.find("div[data-collapsible-body]").each(function () {
      var $el = $(this);
      if ($el.attr("data-repl-uid-body")) return;

      uidCounter++;
      var uid = "footer-repl-body-" + uidCounter;
      origStore[uid] = $el.prop("outerHTML");

      $el.attr("data-repl-uid-body", uid);
      $el.removeAttr("data-collapsible-body");
    });
  }

  function revertToMobile() {
    // Restore everything by UID (footer scoped)
    $footer.find("[data-repl-uid]").each(function () {
      var uid = $(this).attr("data-repl-uid");
      if (origStore[uid]) {
        $(this).replaceWith(origStore[uid]);
        delete origStore[uid];
      }
    });

    $footer.find("[data-repl-uid-body]").each(function () {
      var uid = $(this).attr("data-repl-uid-body");
      if (origStore[uid]) {
        $(this).replaceWith(origStore[uid]);
        delete origStore[uid];
      }
    });
  }

  function onMqChange(e) {
    if (e.matches) {
      transformToDesktop();
    } else {
      revertToMobile();
    }
  }

  // initial load
  onMqChange(mq);

  // listen for viewport changes
  if (mq.addEventListener) {
    mq.addEventListener("change", onMqChange);
  } else if (mq.addListener) {
    mq.addListener(onMqChange);
  }
});

// click outside to close open dropdown menus on desktop
$(document).ready(function () {
  // Check clicks anywhere on the page
  $(document).on("click", function (e) {
    // Check if the clicked target is NOT inside the nav
    if (!$(e.target).closest(".header__menu").length) {
      // Remove "is-visible" class from all <click-disclosure>
      $("click-disclosure.is-visible").removeClass("is-visible");

      // Also hide any dropdowns (remove visible classes and reset styles)
      $(".header__dropdown").removeClass("is-visible").hide();

      // Reset arrow rotation or aria attributes if needed (optional)
      $(".navlink--toplevel").attr("aria-expanded", "false");
    }
  });
});

//  not closing dropdown on inner click
$(document).ready(function () {
  // Prevent any click inside the dropdown from closing it
  $(".header__dropdown").on("click", function (e) {
    e.stopPropagation();
  });
});

$(document).ready(function () {
  $(".badge-box").each(function () {
    if ($.trim($(this).text()) === "") {
      $(this).hide();
    }
  });
});
